module.exports = __webpack_public_path__ + "img/pingan.5ebfdbb2.png";